import firestore from "../firebase/firestore";

export const removeNegativation = (negativation, data) => {
  return firestore
    .collection("users")
    .doc(negativation.user_id)
    .collection("negativation")
    .doc(negativation.id)
    .update(data);
};
